
<div class="collapse">
  <div data-testid="collapse-head" class="head" (click)="showList = !showList" [class]="extraClass" [ngStyle]="{'padding': !fromFollowUp ? '20px 0px' : '0px' }"><span class="flex"><i class="icons {{iconClass}}" *ngIf="iconClass"></i>
      <div data-testid="collapse-title" class="title" [class]="extraClass">{{title}}&nbsp;</div>
      <div class="title" *ngIf="shortName" [class]="extraClass">({{shortName}})</div></span>
    <div class="dropDownIcon" [ngClass]="{'rotate': showList}"><i class="fas fa-chevron-right fontL1"></i></div>
  </div>
  <div *ngIf="showList" [ngClass]="{'body': !fromFollowUp, 'followUpSop': fromFollowUp}">
    <ng-content></ng-content>
  </div>
</div>